/**
 * 微信分享卡片缩略图（需绝对 HTTPS URL）。
 * 使用铺满的方角图：微信自己会裁圆角；若 PNG 四角透明，微信常填成白色，
 * 在深色手机上会出现难看的白角。
 * ?v= 用于刷新微信侧缩略图缓存。
 */
export const APP_SHARE_IMAGE_PATH = "/app-share-icon.png?v=20261027";

export function appShareImageUrl(origin?: string): string {
  const path = APP_SHARE_IMAGE_PATH;
  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }
  if (origin) return `${origin.replace(/\/$/, "")}${path}`;
  return path;
}
